import {createContext, useEffect, useState} from "react";
import axios from "axios";
import {Config, languageOptions} from "../config/Config";

export const TranslationContext = createContext();

export const TranslationProvider = ({children}) => {
    const getBrowserLang = () => {
        if (localStorage.getItem("language")) {
            const lang = localStorage.getItem("language");
            if (languageOptions.hasOwnProperty(lang)) {
                return localStorage.getItem("language");
            } else {
                localStorage.removeItem("language");
            }
        }
        const nav = window.navigator;
        const browserLang = nav.language || nav.userLanguage;
        return Config.browserLanguageMap[browserLang] || "cs"; // languages is the mapping object mentioned in the previous example
    };

    const [translations, setTranslations] = useState({});
    const [data, setData] = useState({});
    const [language, setLanguage] = useState(getBrowserLang);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        const fetchTranslations = async () => {
            const response = await axios.get(`/public/translations.json?t=${new Date().getTime()}`);
            setData(response.data);
            setTranslations(response.data[language]);
            setLanguages(Object.keys(response.data));
        };
        fetchTranslations();
    }, []);

    useEffect(() => {
        setTranslations(data[language]);
    }, [language]);

    const setAppLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        localStorage.setItem("language", newLanguage);
    }

    return (
        <TranslationContext.Provider value={{translations, language, setAppLanguage, languages}}>
            {children}
        </TranslationContext.Provider>
    );
};
